import styled from "styled-components";
import { RichTextInput } from "./richTextInput";

export const FormRichInput = styled(RichTextInput)`
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
	border-radius: 16px;

	.public-DraftEditor-content,
	.public-DraftEditorPlaceholder-root {
		min-height: 100px;
		padding: 10px 12px 9px;
		font-size: 0.8125rem;
	}
	.public-DraftEditorPlaceholder-root {
		font-weight: 400;
		opacity: 0.8;
	}
`;
